<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>
          {{ isFormView ? 'Registrar detalle de remisión de venta' : 'Detalle de remisión de venta' }}
        </h6>
      </div>
      @if (!swOrderModule) {
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledDetail" [width]="'7rem'"
          (onClick)="openArticleSelectionModal()">
        </app-custom-button>
        <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Artículos'"
          [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
          (selectedItems)="handleSelectedItem($event)" hidden>
        </app-custom-modal>
      </div>
      } @else {
      <!-- Pedido(Masivo) -->
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-1">
        <app-custom-button [label]="'Ped.Masivo'" [severity]="'success'" [disabled]="disabledDetail" [width]="'6.2rem'"
          [icon]="'pi pi-user-plus'" (onClick)="openMassiveOrderSelectionModal()">
        </app-custom-button>
        <app-custom-modal #salesRemissionMassiveOrderSelection [label]="'Seleccionar'" [width]="'80vw'"
          [header]="'Pedido Masivo'" [children]="componentSalesRemissionMassiveOrder"
          [inputs$]="inputsForMassiveOrderModals$" (selectedItems)="handleMassiveOrderSelection($event)" hidden>
        </app-custom-modal>
        <!-- Pedido(Manual) -->
        <app-custom-button [label]="'Ped.Manual'" [severity]="'success'" [disabled]="disabledDetail" [width]="'6.2rem'"
          [icon]="'pi pi-user-edit'" (onClick)="openManualOrderSelectionModal()">
        </app-custom-button>
        <app-custom-modal #salesRemissionManualOrderSelection [header]="'Pedido Manual'" [label]="'Seleccionar'"
          [width]="'80vw'" [inputs$]="inputsForManualOrderModals$" [children]="componentSalesRemissionManualOrder"
          hidden (selectedItems)="handleSelectedItem($event)">
        </app-custom-modal>
      </div>
      }
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-sales-remission-detail [salesRemissionDetails]="salesRemissionDetails"
          [swOrderModule]="swOrderModule" [salesRemissionModel]="salesRemissionModel"
          [salesRemissionDetailContract]="salesRemissionDetail" [permissionUpdatable]="permissionUpdatable"
          (isFormView)="getFormView($event)" (updateListDetail)="getSalesRemissionDetailsForCaptureTable()">
        </app-register-sales-remission-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]="!this.disabledDetail" [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getSalesRemissionDetailsForCaptureTable()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>